<template>
  <!-- type == 1 用户提问的type == 2 医生回答的type == 3 管理员 -->
  <div id="detail-container" class="g-main" :class="{'for-service': quesDetail.status === 1 && !quesDetail.doctorId,'in-service' : quesDetail.status === 1 && quesDetail.doctorId, 'out-of-service': quesDetail.status === 2, 'denial-of-service': quesDetail.status === 4}">
    <!-- 底部提示区域 -->
    <div class="top-tips-box border2">医生将在1小时内回答您的问题</div>

    <!-- 消息列表 -->
    <div ref="msgList" class="list-message-box" @scroll="onListScroll" @touchstart="saveTouchY" @touchmove="computTouchY">
      <ul>
        <!-- 医生详情 -->
        <li class="msg-of-doctor">
          <transition name="fade">
          <Doctor :doctor="doctor" v-if='doctor && !hasHistoryMsg' :type="2" :id="quesDetail.doctorId" transiton="fade"></Doctor>
          </transition>
        </li>

        <!-- 数据加载中提示 -->
        <li class="msg-loading-box" v-if="listScroll.isLoading"></li>

        <!-- 提示类型 -->
        <li class="msg-of-tips">
          <p>医生的回复仅为建议，具体诊疗请前往医院进行</p>
        </li>

        <!-- 消息体-->
        <li class="msg-item" v-for="item in filterMessage(quesDetail.details)">
            <div class="msg-of-time">{{ dateFormat(item.msgTime) }}</div>

            <!-- 如果是语音消息 -->
            <div class="msg-content msg-of-audio" :class="{'is-loading': audioObj.playId === item.id,'is-playing': audioObj.isCanPlay && audioObj.playId === item.id}" v-if="item.content.type === 'audio'">
              <audio ref="listaudio" :src="item.content.file" preload="auto"></audio>
              <!-- 用户图像 -->
              <router-link tag="div" class="msg-of-avatar" v-if="item.type !== 1" :to="'/doctor/' + quesDetail.doctorId + '?hideNav=1'">
                <template v-if="item.url">
                  <img :src="item.url">
                </template>
                <template v-else>
                  <!-- 如果是专家 -->
                  <img src="./../assets/images/expert.png" v-if="item.type === 2" data-track="yy_djk_kwys_xqys">
                  <!-- 如果是管理员 -->
                  <img src="./../assets/images/expert.png" v-if="item.type === 3">
                </template>
              </router-link>

              <!-- 信息主体 -->
              <div class="msg-of-detail">
                <!-- 昵称 -->
                <div class="msg-of-nickname">{{item.name}}</div>
                <!-- 消息体 -->
                <div class="msg-of-content border3" @click="playAudio(item.id, $event)">
                  <div class="media-wrap" :style="{'animation-duration': audioObj.duration + 's'}"></div>
                  <img src="./../assets/images/audio-loading.gif" class="loading-status">
                  <img src="./../assets/images/for-play@2x.png" class="to-play-status">
                  <img src="./../assets/images/playing.gif" class="playing-status">
                  <div class="msg-of-time-show"></div>
                  <!--<div class="msg-of-time-show">{{ $refs.listaudio}}</div>-->
                  <div class="msg-of-unread" v-if="item.readStatus !== 1"></div>
                </div>
              </div>
            </div>

            <!-- 非语音消息 -->
            <div class="msg-content" v-else :class="{'msg-of-text': item.content.type ==='text','msg-of-img': item.content.type === 'image', 'position-right':item.type === 1, 'send-fail-status': item.sendStaus == '1'}">
              <!-- 用户图像 右侧 -->
              <router-link tag="div" class="msg-of-avatar" v-if="item.type !== 1" :to="'/doctor/' + quesDetail.doctorId + '?hideNav=1'" data-track="yy_djk_kwys_xqys">
                <!-- 如果是专家 -->
                <template v-if="item.type === 2">
                  <img :src="item.url" v-if="item.url" data-track="yy_djk_kwys_xqys">
                  <img src="./../assets/images/expert.png" v-else data-track="yy_djk_kwys_xqys">
                </template>
                <template v-if="item.type === 3">
                  <img :src="item.url" v-if="item.url">
                  <img src="./../assets/images/expert.png" v-if="item.type === 2">
                </template>
              </router-link>

              <!-- 信息主体 -->
              <div class="msg-of-detail" >
                <!-- 昵称 -->
                <div class="msg-of-nickname">{{item.name || '佚名'}}</div>

                <!-- 文字类型 -->
                <div class="msg-of-content" v-if="item.content.type === 'text'">
                  {{item.content.text}}
                  <div class="btn-send" @click="sendAgain(item.id, $event)" v-if="item.type === 1"></div>
                </div>

                <!-- 图片类型 -->
                <div class="msg-of-content border3" v-if="item.content.type === 'image'">
                  <div class="preview-img" v-if="item.content.file">
                    <img class="preview-img" @click="preview(item.id)" :src="item.type === 1 ? item.content.smallUrl : item.content.file" alt="">
                  </div>
                  <img src="./../assets/images/placeholder.png" alt="" v-else>
                  <div class="btn-send" @click="sendAgain(item.id, $event)" v-if="item.type === 1"></div>
                </div>
              </div>

              <!-- 用户图像 左侧 -->
              <div class="msg-of-avatar" v-if="item.type === 1">
                <img :src="item.url" v-if="item.url">
                <img src="./../assets/images/member.png" v-else>
              </div>
            </div>
          </li>
      </ul>
    </div>

    <!-- 底部输入操作框 -->
    <div class="bottom-toolbar-box border5">
      <!-- 基本输入框 -->
      <div class="base-input-box">
        <textarea rows="1" placeholder="输入文字描述病情..." @focus="onInputFocus" class="base-input-area border1" v-model="sendMes"></textarea>
        <div class="file-input-wrap needsclick" @click.self="chooseImageCmd" data-track="yy_djk_kwys_xqtpsc"></div>
        <button class="send-msg-cmd" :class="{ disabled: isSend }" :disabled="isSend" @click="onSendTextCmd" data-track="yy_djk_kwys_xqfs">发送</button>
        <form class="hidden-form" enctype="multipart/form-data">
          <input class="needsclick" type="file" ref="inputFile" id="file-input-placeholder" accept="image/*" @change="fileUploadChange" name="image" multiple="multiple">
        </form>
      </div>
    </div>

    <!-- 问题关闭后的操作按钮 -->
    <div class="question-end-box border5">
      <div class="question-end-tips">问题已自动关闭</div>
      <div class="question-end-opt">
        <!-- 是否已经评价 -->
        <router-link tag="button" :to="{path: '/rate/' + interrogationid + '/' + quesDetail.doctorId + '/' + '?hideNav=1'}" v-if="quesDetail.commentStatus === 0" data-track="yy_djk_kwys_pj">
          去评价
        </router-link>
        <button class="disabled-btn" v-else>已评价</button>
        <router-link tag="button" :to="{path: '/question?hideNav=1'}" data-track="yy_djk_kwys_tzwqtwt">再问其他问题</router-link>
      </div>
    </div>

    <!-- 操作蒙层 -->
    <div class="opt-mask" @touchstart="onHideOptMask" v-if="isShowOptMask"></div>
  </div>
</template>

<script>
  // import Vue from 'vue';
  import {mapState} from 'vuex';
  import _ from 'lodash';
  import Doctor from '../components/Doctor';
  import {preventShowBoundary} from '../assets/utils';

  export default {
    name: 'detail',
    data() {
      return {
        listScroll: {
          isLoading: false,             // 消息是否正在上拉加载
          scrollId: null,               // 节流定时器id
          lastScrollHeight: ''         // 上一次滚动时页面的位置
        },
        isShowOptMask: false,           // 是否显示操作蒙层
        quesDetail: {},                 // 问题详情内容
        pollId: null,                   // 轮询消息定时器的id
        audioContent: null,             // audio对象
        audioObj: {
          isCanPlay: false,            // 音频是否可以播放
          playId: null,                // 当前播放的音频的id
          duration: 0,                 // 音频总长度
          playIndex: 0,                // 在待播放列表中的数组索引
          isNeedPlayNext: true        // 是否需要播放下一条语音
        },
        audioArray: [],                // 所有可以播放的音频的列表
        imgArray: [],                  // 所有可以查看的图片列表
        hasHistoryMsg: true,           // 是否有历史消息
        titleBar: [{                   // 顶部标题的文案和颜色 0 - 未支付
          title: '',
          tips: '问题已关闭',
          color: '#888888'
        }, {                           // 1 - 已支付
          title: '',
          tips: '23小时或20次对话后问题关闭',
          color: '#FF9000'
        }, {                          // 2 - 已关闭
          title: '',
          tips: '问题已关闭',
          color: '#888888'
        }, {                          // 3 - 已退款
          title: '',
          tips: '问题已关闭',
          color: '#888888'
        }, {                          // 4 - 异常关闭（违规等）
          title: '',
          tips: '问题已关闭',
          color: '#888888'
        }, {                          // 5 - 订单超时未支付
          title: '',
          tips: '问题已关闭',
          color: '#888888'
        }, {                          // 对话次数已达上限（自己加的，后台没有这个状态）
          title: '',
          tips: '问题已达对话次数上限',
          color: '#888888'
        }, {                          // 对话时间已达上限（自己加的，后台没有这个状态）
          title: '',
          tips: '问题已达对话时间上限',
          color: '#888888'
        }],
        interrogationid: null,
        isSend: false, // 是否在发送消息
        isHistory: false, // 是否在查看历史消息
        clientY: null, // Y坐标
        sendMes: ''
      };
    },
    components: {Doctor},
    computed: {
      ...mapState([
        'doctor'
      ])
    },
    beforeCreate() {
      window.VM = this;

      // 更新顶部状态
      this.$store.dispatch('updateNav', {
        title: '问题详情',
        type: 'center',
        tips: '',
        color: 'rgb(255, 144, 0)'
      });
    },
    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_ym_wtxq', '');
      }
      // 创建音频播放对象
      this.createAudio();
      // 获取问题详情
      this.getDetail(this.$route.params.id);
      this.interrogationid = this.$route.params.id;

      // FIXME: 需要加安卓的判断 安卓兼容
      if (window.MT && window.MT.softInputAdjustResize) {
        window.MT.softInputAdjustResize();
      }
    },
    mounted() {
      preventShowBoundary('.list-message-box, [role=dialog]');
    },
    destroyed() {
      clearInterval(this.pollId);         // 清除轮询的定时器
      this.audioContent.pause();          // 停止播放语音
    },
    methods: {
      // 去掉重复消息
      filterMessage(array) {
        const arr = _.uniqBy(array, 'id');
        return arr;
      },

      // 当输入框获取焦点
      onInputFocus() {
        this.isShowMask(true);            // 显示操作蒙层
        setTimeout(() => {
          this.scrollBodyToBottom();        // 滚动到页面bottom
        }, 300);
      },

      // 输入的时候滑动到蒙层
      onHideOptMask() {
        this.isShowMask(false);           // 隐藏操作蒙层
      },

      // ------------------------ 图片上传相关 ------------------------- //
      // 调用图片上传
      chooseImageCmd() {
        // TODO: 针对安卓放弃 form 上传
        const userAgent = window.navigator.userAgent;
        const index = userAgent.indexOf('Android');

        if (index >= 0 && window.isApp === 1) {
          // android
          window.MT.catchImage(960, 960);

          // 上传成功回调方法
          window.catchFileFinishCall = (base64) => {
            const formData = new FormData(document.querySelector('.hidden-form'));

            window.VM.$store.dispatch('uploadImageBase64', {
              formData,
              url: '/mobile/system/uploadbase64picture.htm',
              type: 'post',
              base64
            }).then((response) => {
              // 判断是否成功
              if (Number.parseInt(response.resultInfo.code, 10) !== 0) {
                this.$dialog.Toast({mes: response.resultInfo.message});
              } else {
                this.sendMsg(JSON.stringify(this.formatUploadArray(response.data.imageUri)), 0);
              }
            });
          };
        } else {
          // ios 非安卓app
          const $fileInput = this.$refs.inputFile; // document.getElementById('file-input-placeholder');
          $fileInput.click();
          this.isShowMask(false);           // 隐藏操作蒙层
        }
      },

      // 选择图片
      fileUploadChange(e) {
        // 获取File对象，这里是上传单张图片，【0】代表第一张图片，如果是多张，就是var file = e.target.files;
        // 判断上传图片的个数
        if (e.target.files.length > 9) {
          this.showToast('你选择的图片数量过多（9张/次）,请重新选择');
          return;
        }
        const form = new FormData(document.querySelector('.hidden-form'));
        this.imageUpload(form);
        e.target.value = '';
      },

      // 上传图片
      imageUpload(formData) {
        this.$store.dispatch('uploadImageByForm', {
          formData,
          url: '/mobile/system/uploadpictures.htm?imagewidth=280&imageheight=750',
          type: 'post'
        }).then((response) => {
          // 判断是否成功
          // 发送图片消息
          // 如果上传成功
          if (Number.parseInt(response.resultInfo.code, 10) !== 0) {
            this.showToast(response.resultInfo.message, 'error');
          } else {
            this.sendMsg(JSON.stringify(this.formatUploadArray(response.data.imagestr)), 0);
          }
        });
      },

      // 生成一个audio对象
      createAudio() {
        this.audioContent = document.createElement('audio');
        this.audioContent.autoplay = false;
        this.audioContent.preload = true;
        this.audioContent.oncanplay = this.onCanplay;
        this.audioContent.onpause = this.onAudioPause;
        this.audioContent.onerror = this.onError;
        document.body.appendChild(this.audioContent);
      },

      // 播放音频
      playAudio(audioSrcId, e) {
        this.audioObj.isCanPlay = false;      // 默认当前音频不可播放
        // 如果音频是一个暂停状态 或者 播放音频的来源不是同一个
        if (this.audioContent.paused || audioSrcId !== this.audioObj.playId) {
          this.audioObj.playId = audioSrcId;
          this.audioContent.src = this.getAudioSrc(audioSrcId).src;
          this.audioContent.play();
          this.audioObj.isNeedPlayNext = true;  // 自动找寻下一个可以播放的音频
        } else {
          this.audioContent.pause();
          this.audioObj.playId = null;          // 播放id 置空
          this.audioContent.src = '';           // 播放链接置空
          this.audioObj.isNeedPlayNext = false;   // 不再自动找寻下一个可以播放的音频
        }
        e.preventDefault();
        e.stopPropagation();
      },

      // 播放出错
      onError() {
        this.audioObj.isNeedPlayNext = false;   // 不再自动找寻下一个可以播放的音频
      },

      // 可以播放
      onCanplay() {
        // 获取音频长度
        this.audioObj.duration = this.audioContent.duration;
        this.audioObj.isCanPlay = true;
      },

      // 音频停止的时候，音频播放完毕了
      onAudioPause() {
        this.audioObj.playId = null;          // 播放id 置空
        this.audioContent.src = '';           // 播放链接置空

        // 检查是否有其他可以播放的音频
        this.getNextNotPlaying();
      },

      // 从待播放的音频数组中找出对应的src
      getAudioSrc(audioId) {
        let forPlayAudio = {};
        this.audioArray.forEach((item, index) => {
          if (item.id === audioId) {
            forPlayAudio = item;
            this.audioObj.playIndex = index;
            // 如果是未播放的，则播放音频
            if (item.isHasPlay !== 1) {
              this.readAudioMsg(this.audioObj.playId);
              this.audioArray[index].isHasPlay = 1;
            }
          }
        });
        return forPlayAudio;
      },

      // 获取当前的 img
      getImgIndex(id) {
        let num = 0;
        this.imgArray.forEach((item, index) => {
          if (parseInt(item.id, 10) === parseInt(id, 10)) {
            num = index;
          }
        });
        return num;
      },

      // 查找下一个未播放的音频
      getNextNotPlaying() {
        if (this.audioObj.isNeedPlayNext) {
          const nextPlayAudio = this.audioArray[this.audioObj.playIndex + 1];
          if (nextPlayAudio) {      // 如果找到了下一个
            if (nextPlayAudio.isHasPlay !== 1) {     // 如果没有听过
              this.playAudio(nextPlayAudio.id);
            } else {
              this.audioObj.playIndex += 1;     // 如果听过，则直接寻找下一个
              this.getNextNotPlaying();
            }
          }
        }
      },

      // 获取历史消息
      getHistoryMsg() {
        // 先获取历史消息
        this.$store.dispatch('getHistoryMsg', {
          lastid: this.quesDetail.details[0] && this.quesDetail.details[0].id,
          interrogationid: this.$route.params.id,
          pagesize: 30
        }).then((response) => {
          if (response) {
            this.renderPage(response, 'history');
          }
        });
      },

      // 轮询获取消息
      pollingLatestMsg() {
        if (this.pollId) {
          clearInterval(this.pollId);
        }
        this.pollId = setInterval(() => {
          this.$store.dispatch('getMsgUnread', {
            lastid: this.quesDetail.details[this.quesDetail.details.length - 1] && this.quesDetail.details[this.quesDetail.details.length - 1].id,
            interrogationid: this.$route.params.id,
            pagesize: '30'
          }).then((response) => {
            if (response) {
              this.renderPage(response, 'new');
            }
          });
        }, 10000);
      },

      // 点击发送按钮，发送文字
      onSendTextCmd() {
        const sendText = document.querySelector('.base-input-area').value;
        if (!sendText) {
          document.querySelector('.base-input-area').focus();
          return;
        }

        this.isShowMask(false);   // 隐藏蒙层

        this.isSend = true; // 设置发送中

        this.sendMes = '';

        // 发送消息
        this.sendMsg(JSON.stringify([{
          type: 'text',
          text: sendText
        }]), 0);
      },

      // 再次发送失败信息
      sendAgain(id, event) {
        const dom = event.target.parentNode.parentNode.parentNode;
        this.sendMsg(id, 1, dom);
      },

      // 发送消息
      sendMsg(content, status, dom, isImage) {
        // 判断是否有继续提问的资格（时间和次数）
        if (Number(this.quesDetail.index, 10) >= '20') {
          this.showToast('问题对话次数已经用光了，去问问其他问题吧');
          return;
        }
        if (Number(this.quesDetail.outTime, 10) >= '24') {
          this.showToast('问题对话时间已经用光了，去问问其他问题吧');
          return;
        }
        const $input = document.querySelector('.base-input-area');    // 内容输入框
        $input.focus();
        let obj = {};

        if (status === 1) {
          obj = {
            id: content
          };

          this.$store.dispatch('sendAskedMsg', obj).then((response) => {
            if (Number.parseInt(response.rtn_code, 10) !== 0) {
              if (Number.parseInt(response.rtn_code, 10) === 9901) {
                this.showToast('问诊信息包含敏感词，请重新输入', 'error');
              } else {
                this.showToast(response.rtn_msg, 'error');
              }
              this.isSend = false; // 设置再次发送
            } else {
              // 发送成功了，拉取最新的消息，并滚动到消息列表底部
              dom.classList.remove('send-fail-status');
            }
          });
        } else {
          obj = {
            interrogationId: this.$route.params.id,
            isImage: isImage ? 1 : 0,
            content
          };

          this.$store.dispatch('sendAskedMsg', obj).then((response) => {
            if (Number.parseInt(response.rtn_code, 10) !== 0) {
              if (Number.parseInt(response.rtn_code, 10) === 9901) {
                this.showToast('问诊信息包含敏感词，请重新输入', 'error');
              } else {
                this.showToast(response.rtn_msg, 'error');
              }
              this.isSend = false; // 设置再次发送
            } else {
              // 发送成功了，拉取最新的消息，并滚动到消息列表底部
              $input.value = '';
              this.$nextTick(() => {
                this.isSend = false; // 发送结束
                if (!this.quesDetail.details) {
                  return;
                }
                this.$store.dispatch('getMsgUnread', {
                  lastid: this.quesDetail.details[this.quesDetail.details.length - 1] && this.quesDetail.details[this.quesDetail.details.length - 1].id,
                  interrogationid: this.$route.params.id,
                  pagesize: '30'
                }).then((res) => {
                  if (res) {
                    this.renderPage(res, 'send');
                  }
                });
              });
            }
          });
        }
      },

      // 读取了一条未读的audio消息
      readAudioMsg(id) {
        this.$store.dispatch('readAudioMsg', {
          id
        });
        // 更改音频的状态
        this.quesDetail.details.forEach((item, index) => {
          if (item.id === id) {
            this.quesDetail.details[index].readStatus = 1;
          }
        });
      },

      // 监听滚动条是否滚动到了底部
      onListScroll(e) {
        // 如果有ajax正在请求加载中，则直接返回
        if (this.listScroll.isLoading) {
          return;
        }
        // 对事件触发进行节流(50ms)
        if (this.listScroll.scrollId) {
          clearTimeout(this.listScroll.scrollId);
        }
        this.listScroll.scrollId = setTimeout(() => {
          if (e.target.scrollTop < 50) {
            // 获取历史消息(如果消息列表框中有值)
            if (this.quesDetail && this.quesDetail.details && this.quesDetail.details.length > 0 && this.hasHistoryMsg) {
              this.listScroll.isLoading = true;
              this.getHistoryMsg();
            }
          }
        }, 50);
      },

      // 获取问题详情
      getDetail(id) {
        this.$store.dispatch('getQuestionDetail', {
          interrogationid: id
        }).then((response) => {
          if (Number.parseInt(response.rtn_code, 10) !== 0) {
            this.showToast(response.rtn_msg, 'error');
          } else {
            // 发送成功了，拉取最新的消息，并滚动到消息列表底部
            this.renderPage(response.data);
          }
        });
      },

      // 渲染页面 1：new 未读的新消息 2：history 历史消息 3：send 发送的消息 4：页面进入时最新的消息
      renderPage(response, type) {
        const $list = document.querySelector('.list-message-box');
        response.details = this.formatMsgList(response.details, type);

        // 更改顶部标题的文案和颜色
        if (response.status) {
          if (Number.parseInt(response.status, 10) === 1) {   //   支付后正常服务状态
            this.updateTitleBar({
              tips: `${24 - response.outTime}小时或者${20 - response.index}次对话后问题关闭`,
              color: Number.parseInt(response.outTime, 10) >= 21 || Number.parseInt(response.index, 10) >= 17 ? '#FF0000' : '#FF9000'
            });
          } else {
            this.updateTitleBar(this.titleBar[response.status]);
          }

          if (Number.parseInt(response.outTime, 10) >= 24) {
            this.updateTitleBar(this.titleBar[7]);
          }
          if (Number.parseInt(response.index, 10) >= 20) {
            this.updateTitleBar(this.titleBar[6]);
          }
        }

        // 默认进入的情形
        switch (type) {
          case 'new':                 // 未读的新消息
            this.quesDetail.details.push(...response.details);
            if (response.details && response.details.length > 0) {      // 说明有新的消息被发送
              this.$set(this.quesDetail, 'status', response.status);    // 更新问题状态
              this.$set(this.quesDetail, 'index', response.index);      // 更新提问次数
              this.$set(this.quesDetail, 'outTime', response.outTime);  // 更新剩余时间
              this.$set(this.quesDetail, 'doctorId', response.doctorId);  // 更新医生信息
              // 如果没有医生信息，就获取医生信息
              if (response.doctorId && !this.doctor) {
                this.getDoctorDetail(response.doctorId);
              }

              if (!this.isHistory) {
                this.scrollListToBottom();
              }
            }
            break;
          case 'history':             // 历史消息 如果列表为空，则说明没有历史记录
            this.quesDetail.details.unshift(...response.details);
            this.$nextTick(() => {
              if (response.details && response.details.length < 30) {
                this.hasHistoryMsg = false;
              }

              this.listScroll.isLoading = false;
              // 滚动到指定位置
              if (this.quesDetail.doctorId) {           // 如果医生接诊了
                $list.scrollTop = ($list.scrollHeight - this.listScroll.lastScrollHeight) - 180;  // 可以适当调整，现在不是很准确
              } else {
                $list.scrollTop = ($list.scrollHeight - this.listScroll.lastScrollHeight) - 80;
              }
              this.listScroll.lastScrollHeight = $list.scrollHeight;
            });
            break;
          case 'send':
            this.quesDetail.details.push(...response.details);
            this.scrollListToBottom(); // 滚动到消息列表底部
            break;
          default:
            this.quesDetail = response;
            this.scrollListToBottom(); // 滚动到消息列表底部
            break;
        }
        // 问题是否关闭，如关闭则什么也不做
        // 轮询最新消息
        this.pollingLatestMsg();

        // 如果有医生的id ，则说明有医生接诊了，此时获取医生信息(如果不是第一次进入，则不获取医生消息)
        if (this.quesDetail && this.quesDetail.doctorId && !type) {
          this.getDoctorDetail(this.quesDetail.doctorId); // 获取医生详情
        }

        // 如果问题被关闭了, 则清除轮序定时器
        if (this.quesDetail.status >= 2) {
          clearInterval(this.pollId); // 清除轮询的定时器
        }
        setTimeout(() => {
          const listAud = this.$refs.listaudio;
          console.log('===audio===', listAud);
          if (listAud) {
            listAud.forEach((value) => {
              if (value.className !== 'added' && value.duration) {
                value.className = 'added';
                const msgDom = value.parentNode.querySelector('.msg-of-time-show');
                msgDom.innerText = `${Math.ceil(value.duration)}s`;
              }
            });
          }
        }, 200);
      },

      // 获取医生详情
      getDoctorDetail(docId) {
        this.$store.dispatch('getDoctorDetail', {
          doctorid: docId
        });
      },

      // 对消息列表的数据进行格式化
      formatMsgList(msgList, type) {
        if (!msgList || (msgList && !msgList.length > 0)) {
          return [];
        }
        const arrImg = [];
        msgList.forEach((item, index) => {
          msgList[index].content = item && item.content ? JSON.parse(item.content)[0] : {};

          // 音频处理
          if (item.content.type === 'audio') {
            this.audioArray.push({
              id: item.id,
              src: item.content.file,
              isHasPlay: item.readStatus
            });
          }

          // 图片处理
          if (item.content.type === 'image') {
            arrImg.push({
              id: item.id,
              src: item.content.file,
              w: 0,
              h: 0
            });
          }
        });

        if (type === 'history') {
          arrImg.reverse();
          arrImg.forEach((item) => {
            this.imgArray.unshift(item);
          });
        } else {
          arrImg.forEach((item) => {
            this.imgArray.push(item);
          });
        }

        return msgList;
      },

      preview(id) {
        window.VM.$preview.open(this.getImgIndex(id), this.imgArray);
      },

      // 格式化日期
      dateFormat(numbers, type) {
        if (!numbers) {
          numbers = (new Date()).getTime();
        }
        const date = new Date(Number(numbers));
        const year = date.getFullYear();
        const month = this.fillNumber(date.getMonth() + 1);
        const day = this.fillNumber(date.getDate());
        const hours = this.fillNumber(date.getHours());
        const minutes = this.fillNumber(date.getMinutes());
        let result = '';
        switch (type) {
          case 'YYYY年MM月DD日':
            result = `${year}年${month}月${day}日`;
            break;
          case 'MM月DD日 HH:MM':
            result = `${month}月${day} ${hours}:${minutes}`;
            break;
          case 'HH:MM':
            result = `${hours}:${minutes}`;
            break;
          default:
            result = `${month}-${day} ${hours}:${minutes}`;
            break;
        }
        return result;
      },

      // 格式化为两位数字，如果为 1 则格式化为01
      fillNumber(number) {
        if (number < 0) {
          number = 0;
        }
        return number > 9 ? number : `0${number}`;
      },

      // 格式化批量上传数组
      formatUploadArray(imgArray) {
        // android
        console.log(typeof imgArray);
        if (typeof imgArray === 'string') {
          return [{
            file: imgArray,
            type: 'image'
          }];
        }

        // ios
        return imgArray.map((item, index) => {
          console.log(index);
          return {
            file: item,
            type: 'image'
          };
        });
      },

      // 滚动body到页面的底部
      scrollBodyToBottom() {
        const $body = document.querySelector('body');
        $body.scrollTop = $body.scrollHeight;
      },

      // 滚动msg-list到底部
      scrollListToBottom() {
        setTimeout(() => {
          const $list = this.$refs.msgList;
          $list.scrollTop = $list.scrollHeight - $list.offsetHeight;
          this.listScroll.lastScrollHeight = $list.scrollHeight;
        }, 50);
      },

      // 是否是底部
      isScrollListBottom() {
        const $list = this.$refs.msgList;
        const bottomOffset = $list.scrollHeight - $list.offsetHeight;
        // 设置100像素的误差
        if ($list.scrollTop >= bottomOffset - 260) {
          // 是底部
          return true;
        }
        return false;
      },

      // 是否显示操作蒙层
      isShowMask(isShow) {
        this.isShowOptMask = isShow;
      },

      // 更新顶部标题
      updateTitleBar(options) {
        this.$store.dispatch('updateNav', {
          title: options.title || '问题详情',
          type: options.type || 'tips',
          tips: options.tips || '23小时或20次对话后问题关闭',
          color: options.color || 'rgb(255, 144, 0)'
        });
      },

      // 显示toast
      showToast(msg, status) {
        if (!msg) {
          return;
        }
        this.$dialog.Toast({
          mes: msg,
          icon: status
        });
      },

      // 开始滚动式 记录Y坐标
      saveTouchY(e) {
        this.clientY = e.changedTouches[0].clientY;
      },
      // 结束滚动式 计算方向并给出是否是 查看历史状态
      computTouchY(e) {
        if ((this.clientY - e.changedTouches[0].clientY) < 0) {
          this.isHistory = true;
        } else if (this.isScrollListBottom()) {
          this.isHistory = false;
        }
      }
    },
    watch: {
      isHistory: {
        handler(value) {
          if (value) {
            console.log('=== 正在查看历史的状态 ===');
          } else {
            console.log('=== 正在查看最新消息的状态 ===');
          }
        },
        deep: false
      }
    }
  };
</script>

<style lang="less" src="./../assets/detail.less" scoped></style>



// WEBPACK FOOTER //
// Detail.vue?6637374e